<template>
  <div class="contract-common">
    <div>
      <b-form-group>
        <label> Chọn cửa hàng:<b class="text-danger">*</b> </label>
        <SearchStore
          :onSubmiting="onSubmiting"
          :storeId="contractData.storeId"
          :storeName.sync="contractData.store.name"
          v-on:onStoreSelected="onStoreSelected"
          :disable="contractData.id || isDisabled"
        />
      </b-form-group>
      <b-form-group>
        <label>
          Mã hợp đồng:<b class="text-danger">*</b>
          <!-- <span class="text-primary" v-html="pointText"></span> -->
        </label>
        <b-input-group>
          <template #append>
            <b-button
              size="sm"
              style="width: 40px"
              variant="secondary"
              v-b-tooltip.hover
              title="Tạo mã hợp đồng ngẫu nhiên"
              @click="generateContractCode"
              :disabled="isDisabled"
            >
              <i class="fa fa-random" aria-hidden="true"></i>
            </b-button>
          </template>
          <template class="relative">
            <b-form-input
              placeholder="Nhập mã hợp đồng"
              size="sm"
              class="text-left"
              v-model="contractData.contractNumber"
              :disabled="isDisabled"
            ></b-form-input>
          </template>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <label>Ngày hợp đồng:<b class="text-danger">*</b> </label>
        <date-picker
          placeholder="Chọn ngày làm hợp đồng"
          class="form-control form-control-sm"
          :config="dpConfigs.date"
          v-model="contractData.contractDate"
          :disabled="isDisabled"
        ></date-picker>
      </b-form-group>

      <b-form-group>
        <label>Địa điểm giao hàng:<b class="text-danger">*</b></label>
        <b-form-textarea
          v-model="contractData.shippingAddress"
          size="sm"
          class="input-style"
          :placeholder="'Thêm địa điểm giao hàng'"
          :rows="6"
          :max-rows="6"
          :disabled="isDisabled"
        ></b-form-textarea>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import moment from 'moment';
// import { makeToastFaile } from '../../../utils/common';
import SearchStore from '@/view/components/stores/SearchStore.vue';

export default {
  props: ['action', 'contractData', 'isDisabled'],
  components: {
    SearchStore,
  },
  data() {
    return {
      onSubmiting: false,
      searchStore: '',
      contractNumber: null,
      contractDate: null,
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
    };
  },
  mounted() {
    this.contractData.contractDate = moment(
      this.action === 'update' ? this.contractData.contractDate : new Date(),
    ).format('DD/MM/YYYY');
  },
  methods: {
    onStoreSelected(storeId) {
      this.contractData.storeId = storeId;
      // this.resetEmployData();
      // // this.fetchShiftWorkConfig();
      // this.inputSearchProductProp.disabled = false;
      // this.listBillItem = [];
    },
    generateContractCode() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const randomNumber = Math.floor(1000 + Math.random() * 9000); // 4 số ngẫu nhiên

      // Lấy 4 ký tự cuối của UUID (để rút ngắn độ dài)
      const shortId = this.contractData.storeId
        ? this.contractData.storeId.slice(-4).toUpperCase()
        : '';

      this.contractData.contractNumber = `HD${year}${month}${day}-${
        shortId ? `${shortId}-` : '-'
      }${randomNumber}`;
    },
  },
};
</script>

<style></style>
